// extracted by mini-css-extract-plugin
export var carrierIcon = "_y3-0";
export var carrierLogo = "_y3-1";
export var detailsSection = "_y3-2";